module.exports = __webpack_public_path__ + "static/media/file.5fe10b60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/UI/FilenameWithIcon/file.svg
// module id = 728
// module chunks = 3